/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxfAccountingV1ConfigEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXF_ACCOUNTING_V1_CONFIG_EVENT_ENTITY_NAME = 'ixf.accounting.v1.ConfigEvent';
export const ixfAccountingV1ConfigEventEntity = new schema.Entity<IxfAccountingV1ConfigEvent>(IXF_ACCOUNTING_V1_CONFIG_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxfAccountingV1ConfigEvent) => `${entity.metadata?.eventId}` });

